module.exports = __webpack_public_path__ + "static/media/mardi-gras-2024.38cbb2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/mardi-gras-2024.png
// module id = 199
// module chunks = 0